'use strict';

+function () {

    angular.module('bg.spreadit', []);
}();